export const CONSTANT_VARIABLE = {
    backgroundPrimaryColor: '#973CB6',
    backgroundMainColor: '#f6f4f4',
    backgroundSidebarColor: '#ffffff',
    mainTextColor: '#313131',
    bgType: 'gradiant',
    sidebarType: 'left'
}